import script from "./Default.vue?vue&type=script&lang=ts&setup=true"
export * from "./Default.vue?vue&type=script&lang=ts&setup=true"

import "./Default.vue?vue&type=style&index=0&id=cccb758a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cccb758a"]])

export default __exports__